import useResizeObserver from '@react-hook/resize-observer'
import { useCallback, useLayoutEffect, useState } from "react";
import { getCoords } from '../utils/get-cords';

export function useSize(recalcDep: any = true) {
  const [size, setSize] = useState<DOMRect>();
  const [target, setTarget] = useState<HTMLDivElement>(null);

  const getNode = useCallback((node: HTMLDivElement) => {
    setTarget(node);
  }, []);

  useLayoutEffect(() => {
    if (target && recalcDep) {
      const rect = target.getBoundingClientRect();
      const { top, left } = getCoords(target);
      setSize({ ...rect, top, left, width: target.clientWidth, height: target.clientHeight })
    }
  }, [target, recalcDep]);

  useResizeObserver(target, entry => {
    const rect = target.getBoundingClientRect();
    const { top, left } = getCoords(target);
    if (target) { setSize({ ...rect, top, left, width: entry.target.clientWidth, height: entry.target.clientHeight }); }
  });

  return { size, getNode };
};
